<template>
  <span
    class="ui-badge"
    :class="[`ui-badge--${variant}`, `ui-badge--${size}`]"
  >
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'UiBadge',
  props: {
    variant: {
      type: String,
      default: 'default',
      validator: v => ['default', 'accent', 'accentSoft', 'success', 'warning', 'danger', 'outline'].includes(v),
    },
    size: {
      type: String,
      default: 'sm',
      validator: v => ['sm', 'md'].includes(v),
    },
  },
};
</script>

<style scoped lang="scss">
.ui-badge {
  display: inline-flex;
  align-items: center;
  font-family: var(--font-sans);
  font-weight: var(--weight-bold);
  letter-spacing: 0.8px;
  border-radius: 2px;
  border: 1px solid transparent;
  white-space: nowrap;
  line-height: 1;
}

/* ── Sizes ── */
.ui-badge--sm {
  padding: 3px 7px;
  font-size: 10px;
}
.ui-badge--md {
  padding: 5px 9px;
  font-size: 11px;
}

/* ── Variants ── */
.ui-badge--default {
  background: var(--color-surface3);
  color: var(--color-text);
}

.ui-badge--accent {
  background: var(--color-accent);
  color: #ffffff;
}

.ui-badge--accentSoft {
  background: var(--color-accentSoft);
  color: var(--color-accent);
}

.ui-badge--success {
  background: var(--color-success);
  color: #ffffff;
}

.ui-badge--warning {
  background: var(--color-warning);
  color: #000000;
}

.ui-badge--danger {
  background: var(--color-danger);
  color: #ffffff;
}

.ui-badge--outline {
  background: transparent;
  color: var(--color-text);
  border: 1px solid var(--color-borderHi);
}
</style>
